module.exports = __webpack_public_path__ + "static/media/illustration-section-05.fed17470.svg";